(function () {
  const gate = document.querySelector('[data-vip-gate]');
  if (!gate) return;

  const storageKey = gate.dataset.storageKey;
  const password = gate.dataset.password;
  const form = gate.querySelector('[data-vip-gate-form]');
  const input = gate.querySelector('[data-vip-gate-input]');
  const error = gate.querySelector('[data-vip-gate-error]');

  function unlock() {
    gate.classList.add('vip-gate--unlocking');
    document.documentElement.classList.remove('vip-gate-active');
    document.body.style.overflow = '';

    window.setTimeout(function () {
      gate.remove();
    }, 600);
  }

  function showError() {
    if (!error) return;
    error.hidden = false;
    input.classList.add('vip-gate__input--error');
    input.setAttribute('aria-invalid', 'true');
    input.focus();
  }

  function hideError() {
    if (!error) return;
    error.hidden = true;
    input.classList.remove('vip-gate__input--error');
    input.removeAttribute('aria-invalid');
  }

  if (sessionStorage.getItem(storageKey) === 'granted') {
    unlock();
    return;
  }

  document.documentElement.classList.add('vip-gate-active');
  document.body.style.overflow = 'hidden';

  requestAnimationFrame(function () {
    gate.classList.add('vip-gate--visible');
  });

  if (form && input) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideError();

      if (input.value === password) {
        sessionStorage.setItem(storageKey, 'granted');
        document.body.style.overflow = '';
        unlock();
      } else {
        showError();
      }
    });

    input.addEventListener('input', hideError);
  }
})();
